import type { DimensionFragmentFragmentDoc } from '@packages/gql/generated/shopping/DimensionFragmentFragmentDoc';
import type { RawProductQuery } from '@packages/gql/generated/shopping/graphql';
import { unmask } from '@packages/gql/src/betterMasking';

export type DimensionsForTracking = NonNullable<RawProductQuery['product']>['dimensions'];

export function getAddToBasketColorString(dimensions: DimensionsForTracking) {
  return (
    dimensions
      .map((dimension) => unmask<typeof DimensionFragmentFragmentDoc>(dimension))
      .filter((dimension) => dimension?.axisType === 'COLOR')
      .pop()
      ?.values.filter((value) => value.isSelected === true)
      .map((selectedValue) => selectedValue.displayText)
      .join('') ?? ''
  );
}
